const DEEP_TRACKING_APIS = ['startupData.Region', 'userProfile.Preferences'];

export const hasSecondLevelTracking = (
    firstLevel: string,
    secondLevel: string,
) =>
    DEEP_TRACKING_APIS.some(trackingPath => {
        const [first, second] = trackingPath.split('.');
        return first === firstLevel && second === secondLevel;
    });

export const shouldTrackProp = (propName: string) =>
    DEEP_TRACKING_APIS.includes(propName);
